document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('#search-bar input[type="text"]');
  const searchButton = document.querySelector('#search-bar button'); // Or a more specific selector
  const searchIcon = document.querySelector('.search-icon svg'); 
  const searchBar = document.getElementById('search-bar');
  const overlay = document.getElementById('overlay');


  function performSearch() {
    const query = searchInput.value.trim();
    if (query) {
      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    } else {
      alert('Моля, въведете текст за търсене!');
    }
  }

  function showSearchBar() {
    searchBar.classList.add('show');
    overlay.classList.add('show');
    document.body.style.overflow = 'hidden';
    searchInput.focus();
  }

  function hideSearchBar() {
    searchBar.classList.remove('show');
    overlay.classList.remove('show');
    document.body.style.overflow = 'auto';
  }

  // Attach event listeners if elements exist
  if (searchButton) {
    searchButton.addEventListener('click', performSearch);
  }

  if (searchInput) {
    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        performSearch();
      }
    });
  }

  if (searchIcon) {
    searchIcon.addEventListener('click', function (event) {
      event.preventDefault();
      showSearchBar();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', hideSearchBar);
  }
});
       const searchButton = document.getElementById('search-button'); 
  const searchInput = document.getElementById('search-input'); 

  function performSearch() { 
    const query = searchInput.value.trim(); 
    if (query) { 
      // Redirect to the search results page or process the search 
      window.location.href = `/search?q=${encodeURIComponent(query)}`; 
    } else { 
      alert('Моля, въведете текст за търсене!'); 
    } 
  } 

  searchButton.addEventListener('click', performSearch); 

  searchInput.addEventListener('keydown', function (event) { 
    if (event.key === 'Enter') { 
      performSearch(); 
    } 
  }); 
        const drawerToggle = document.getElementById('drawer-toggle'); 
  const drawerMenu = document.getElementById('drawer-menu'); 
  const drawerClose = document.getElementById('drawer-close'); 
  const menuToggles = document.querySelectorAll('.menu-toggle'); 
  const openDrawerMenu = () => { 
    if (drawerMenu) { 
      drawerMenu.classList.add('open'); 
      document.body.style.overflow = 'hidden'; 
    } 
  }; 

  const closeDrawerMenu = () => { 
    if (drawerMenu) { 
      drawerMenu.classList.remove('open'); 
      document.body.style.overflow = 'auto'; // Restore scrolling 
    } 
  }; 
  const toggleMenuSection = (button) => { 
    const targetId = button.dataset.target; 
    const targetMenu = document.getElementById(targetId); 
    const toggleIcon = button.querySelector('.toggle-icon'); 

    if (targetMenu && toggleIcon) { 
      if (targetMenu.classList.contains('expanded')) { 
        targetMenu.classList.remove('expanded'); 
        toggleIcon.textContent = '+'; // Change icon to '+' when collapsed 
      } else { 
        targetMenu.classList.add('expanded'); 
        toggleIcon.textContent = '-'; // Change icon to '-' when expanded 
      } 
    } 
  }; 
  if (drawerToggle) { 
    drawerToggle.addEventListener('click', openDrawerMenu); 
  } 

  if (drawerClose) { 
    drawerClose.addEventListener('click', closeDrawerMenu); 
  } 

  menuToggles.forEach((toggle) => { 
    toggle.addEventListener('click', (e) => { 
      toggleMenuSection(e.currentTarget); 
    }); 
  }); 

  const menuLinks = document.querySelectorAll('.list-menu li a'); 
  menuLinks.forEach((link) => { 
    link.addEventListener('click', function () { 

      menuLinks.forEach((item) => { 
        item.classList.remove('active'); 
      }); 
      this.classList.add('active'); 
    }); 
  });        

